import { DialogObject } from '@/components/dialog/dialog.types';
import { FundingSourceRepository } from '@/store/funding-source-state/funding-source-state.repository';

interface getFundingSourceDeleteObjectProps {
  store: FundingSourceRepository;
  action?: () => void;
  toggleVisiblity?: () => void;
}

export const getFundingSourceDeleteObject = ({ store, action, toggleVisiblity }: getFundingSourceDeleteObjectProps): DialogObject => {
  return {
    title: 'fundingSources.delete.title',
    description: 'fundingSources.delete.description',
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'common.delete',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'common.cancel',
        onClick: () => {
          toggleVisiblity?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
